import $ from 'jquery'
import { $elementExists } from './shared'
import { setInstallmentsCookies, getInstallmentsCookies } from './cookies'
import { selectors } from './selectors'

/**
 * Custom CarouselSeloctor
 * --------------------------------------
 * element class: carousel_slider,
 * dispatching event: carouselChange
 * event value: event.detail.value
 */

const directionsEnum = {
    left: 'left',
    right: 'right',
}

/*  ----------------------
    Set default positions
    ---------------------- */

/**
 *
 * @type {*[
 *     {
 *         value: number,
 *         position: number,
 *         checked: boolian
 *     }
 * ]}
 */
const installmentsPositionMap = []

const selector_config = {
    use_cookies: [selectors.sliders.installmentsCalculator, selectors.sliders.installmentsHomepage, selectors.sliders.installmentsLoan],
    no_cookies: [selectors.sliders.installmentsOfferpage],

    // Set default month
    DEFAULT: 6,

    IN_VIEW: 3,
}

const selector_props = {
    // Slider container global
    container_selector: '[data-selector-container]',
    options_selector: '[data-selector-option]',
    buttons_selector: ['[data-selector-left]', '[data-selector-right]'],

    // Index used to calculate position of each instalment
    SHIFT: 0,

    // Index of selected element
    FOCUS: 0,
}

export const initCarouselSelector = () => {
    const { selector, cookies } = sliderExists()

    /** ---------------------------------
     * End program if no element exists
     ------------------------------------ */
    if (!selector) return

    /**
     * Run through possible installment options first
     * and create map of values with indexes and checked state
     */
    mapInstallmentInputs(selector)
    setInitialPosition(cookies ? getInstallmentsCookies() : getDefaultPosition())
    calculateInstPosition(selector)
    /**
     * Default save to cookies only if cookies are allowed
     */
    saveToCookies(cookies)
    selector_props.buttons_selector.forEach((selector) => $(selector).on('click', (event) => onShift(event, cookies)))
    /**
     * Recalculate position on window resize to keep it in the right place, especially when user is changing device orientation.
     */
    initResizeListener()
}

function initResizeListener() {
    let resizeTimer
    $(window).on('resize', () => {
        clearTimeout(resizeTimer)
        resizeTimer = setTimeout(() => calculateInstPosition(), 100)
    })
}

function getDefaultPosition() {
    if (installmentsPositionMap.every((inst) => inst.checked === false)) return selector_config.DEFAULT
    const checkedInput = installmentsPositionMap.find((inst) => inst.checked)
    return checkedInput.value
}

function sliderExists() {
    const possibleSelectors = [...selector_config.use_cookies, ...selector_config.no_cookies]

    const possibleSlider = {
        selector: null,
        cookies: false,
    }

    for (const selector of possibleSelectors) {
        if (!$elementExists($(selector))) continue
        possibleSlider.selector = selector
        possibleSlider.cookies = shouldUseCookies(selector)
        break
    }

    return possibleSlider
}

function shouldUseCookies(selector) {
    if (selector_config.use_cookies.includes(selector)) return true
    if (selector_config.no_cookies.includes(selector)) return false
}

/**
 *
 * @param value = number
 * @returns number
 */
function findIndexByValue(value) {
    const instPropObject = installmentsPositionMap.find((instProp) => instProp.value === parseInt(value))
    if (!instPropObject) return selector_config.DEFAULT
    return instPropObject.position
}

function mapInstallmentInputs(existingInput) {
    $(existingInput)
        .find('input')
        .each(function (index) {
            installmentsPositionMap.push({
                value: parseInt($(this).val()),
                position: index,
                checked: $(this).is(':checked') ? true : false,
            })
        })
}

const shiftPosition = (direction) => {
    switch (direction) {
        case directionsEnum.right:
            selector_props.SHIFT++
            selector_props.FOCUS++
            break
        case directionsEnum.left:
            selector_props.SHIFT--
            selector_props.FOCUS--
            break
    }
}

const setInitialPosition = (position) => {
    /** --------------------------------------------------
     * IF position is outside of MIN MAX boundaries
     * due to out of date cookie value, set value
     * to the closest allowed val.
     -----------------------------------------------------*/

    const valueMin = getCurrentValueByPosition(getBoundaries().min)
    const valueMax = getCurrentValueByPosition(getBoundaries().max)

    if (position < valueMin) position = valueMin
    if (position > valueMax) position = valueMax

    selector_props.SHIFT = position ? findIndexByValue(position) : findIndexByValue(selector_config.DEFAULT)
    selector_props.FOCUS = position ? findIndexByValue(position) : findIndexByValue(selector_config.DEFAULT)
}

const calculateInstPosition = () => {
    const portion = $(selector_props.container_selector).width() / selector_config.IN_VIEW
    const labelWidth = $(selector_props.options_selector).first().innerWidth()
    const toCenter = (portion - labelWidth) / 2
    positionInst(portion, toCenter)
}

const positionInst = (portionW, toCenter) => {
    $(selector_props.options_selector).each((idx, inst) => {
        /**
         *
         * its calculating position of each element and shifting its position from left
         *
         * 1.            (idx - selector_props.SHIFT) * portionW            = result is number of pixels from left positive or negative value.
         * 2. portionW + (idx - selector_props.SHIFT) * portionW            = adds up one portion to shift the left side to the center as default.
         * 3. portionW + (idx - selector_props.SHIFT) * portionW + toCenter = adds up calculated padding to center label within the portion.
         */
        const leftShift = portionW + (idx - selector_props.SHIFT) * portionW + toCenter

        $(inst).css('left', leftShift + 'px')
        selectFocused(idx, $(inst))
    })
}

const selectFocused = (idx, $inst) => {
    if (idx === selector_props.FOCUS) {
        $inst.addClass('carousel_slider--focus')
        const input = $inst.find('input')
        input.prop('checked', true)
        dispatchEvent(input.val())
    } else {
        $inst.removeClass('carousel_slider--focus')
        $inst.css('z-index', '0')
    }
}

function getBoundaries() {
    return {
        min: [...installmentsPositionMap].shift().position,
        max: [...installmentsPositionMap].pop().position,
    }
}

const scrollBreak = (direction) => {
    switch (direction) {
        case directionsEnum.right:
            return selector_props.SHIFT >= getBoundaries().max
        case directionsEnum.left:
            return selector_props.SHIFT < 1 + getBoundaries().min
    }
}

const getCurrentValueByPosition = (position) => {
    const instPropObject = installmentsPositionMap.find((instProp) => instProp.position === position)
    return instPropObject.value
}

const saveToCookies = (setCookies) => {
    if (!setCookies) return
    setInstallmentsCookies(getCurrentValueByPosition(selector_props.SHIFT))
}

const dispatchEvent = (value) => {
    const event = new CustomEvent('carouselChange', {
        detail: {
            value: value,
        },
    })
    document.querySelector('.carousel_slider').dispatchEvent(event)
}

const onShift = (event, setCookies) => {
    if (scrollBreak(event.target.name)) return
    shiftPosition(event.target.name)
    calculateInstPosition()
    saveToCookies(setCookies)
}
